<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '255.255.255.0';
    export let disabled: boolean = false;

    const NETMASKS = [
        { value: '255.0.0.0',       label: '/8  — 255.0.0.0'       },
        { value: '255.255.0.0',     label: '/16 — 255.255.0.0'     },
        { value: '255.255.255.0',   label: '/24 — 255.255.255.0'   },
        { value: '255.255.255.128', label: '/25 — 255.255.255.128' },
        { value: '255.255.255.192', label: '/26 — 255.255.255.192' },
        { value: '255.255.255.224', label: '/27 — 255.255.255.224' },
        { value: '255.255.255.240', label: '/28 — 255.255.255.240' },
        { value: '255.255.255.248', label: '/29 — 255.255.255.248' },
        { value: '255.255.255.252', label: '/30 — 255.255.255.252' },
    ];

    errors[name] = [];

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <select
        {name}
        {disabled}
        bind:value
        class="input-mono"
        on:change
    >
        {#each NETMASKS as mask}
            <option value={mask.value}>{mask.label}</option>
        {/each}
    </select>
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
